/**
 * ログインURL取得
 */
export function useLoginUrl() {
  const getCookies = (): Map<string, string> => {
    const cookies = new Map();

    for (let cookie of document.cookie.split(';')) {
      let cookieArray = cookie.split('=');
      if (cookieArray[0] && cookieArray[1]) {
        cookies.set(cookieArray[0].trim(), cookieArray[1].trim());
      }
    }

    return cookies;
  };

  const getAnalysisParameters = (): string => {
    const utmParam = ['dloan_utm_source', 'dloan_utm_medium', 'dloan_utm_campaign', 'dloan_utm_term'];
    let parameters = '';

    getCookies().forEach((value, key) => {
      if (utmParam.includes(key)) {
        parameters = parameters + `&${key.replace('dloan_', '')}=${value}`;
      }

      if (key === 'dloan_ref') {
        let encodedUrl = encodeURIComponent(value);
        parameters = parameters + `&referenceroute=${encodedUrl}`;
      }

      if (key.match(/^daj_d\d{10}$/g)) {
        parameters = parameters + `&da_uid=${key.replace('daj_', '')}_${value}_30`;
      }
    });

    return parameters;
  };

  const getUrl = (parameter: string): string => {
    // cushionWithUniversalLinkActivationは必ずパラメータが付与される前提
    return `common/login/cushionWithUniversalLinkActivation?${parameter}${getAnalysisParameters()}`;
  };

  return {
    getUrl,
  };
}
